import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CommentAutomationsPage } from '../../comment-automations';
import { DmAutomationsPage } from '../../dm-automations';

type AutomationsTab = 'comments' | 'dms';

const automationsTabs: Array<{ id: AutomationsTab; labelKey: string }> = [
  { id: 'comments', labelKey: 'commentsTab' },
  { id: 'dms', labelKey: 'dmsTab' },
];

const parseTab = (value: string | null): AutomationsTab =>
  automationsTabs.some((tab) => tab.id === value) ? (value as AutomationsTab) : 'comments';

export const AutomationsPage: React.FC = () => {
  const { t } = useTranslation(['automations']);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = parseTab(searchParams.get('tab'));

  const handleTabChange = (tab: AutomationsTab) => {
    const params = new URLSearchParams(searchParams);
    params.set('tab', tab);
    setSearchParams(params, { replace: true });
  };

  return (
    <div className="company-admin-page">
      <div className="company-page-head">
        <h2>{t('title')}</h2>
        <div className="company-tabs" role="tablist" aria-label={t('managementTabs')}>
          {automationsTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`company-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabChange(tab.id)}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </div>
      </div>

      <div className="company-tab-panel">
        {activeTab === 'comments' ? <CommentAutomationsPage /> : null}
        {activeTab === 'dms' ? <DmAutomationsPage /> : null}
      </div>
    </div>
  );
};
